var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "autoReply" }, [
    _c("h2", { staticClass: "normal" }, [_vm._v("自动问答管理")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table", style: { height: _vm.tableHeight + "px" } },
      [
        _c(
          "div",
          { staticClass: "menu" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.append(_vm.currentData, _vm.currentNode)
                  }
                }
              },
              [_vm._v("新增类别")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.append(_vm.currentData, _vm.currentNode, true)
                  }
                }
              },
              [_vm._v("新增答案")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.modify(_vm.currentData, _vm.currentNode)
                  }
                }
              },
              [_vm._v("修改")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.remove(_vm.currentData, _vm.currentNode)
                  }
                }
              },
              [_vm._v("删除")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "normal" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.fold.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v("折叠")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: _vm.movable ? "primary" : "plain" },
                    on: {
                      click: function($event) {
                        _vm.movable = !_vm.movable
                      }
                    }
                  },
                  [_vm._v("移动")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("el-input", {
              staticClass: "normal",
              attrs: { clearable: "", placeholder: "输入关键字搜索答案" },
              model: {
                value: _vm.filterText,
                callback: function($$v) {
                  _vm.filterText = $$v
                },
                expression: "filterText"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "tree-box",
                style: { height: _vm.tableHeight - 150 + "px" }
              },
              [
                _c("el-tree", {
                  ref: "tree",
                  attrs: {
                    data: _vm.treeData,
                    props: _vm.defaultProps,
                    "highlight-current": "",
                    "node-key": "id",
                    "default-expand-all": "",
                    "filter-node-method": _vm.filterNode,
                    draggable: "",
                    "allow-drop": _vm.allowDrop
                  },
                  on: {
                    "current-change": _vm.handleCurrentChange,
                    "node-drop": _vm.handleDrop
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "line" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "question" },
          [
            _c(
              "div",
              [
                _c(
                  "div",
                  { staticClass: "input-box" },
                  [
                    _c("el-input", {
                      attrs: {
                        clearable: "",
                        placeholder: "输入手动录入的问题"
                      },
                      model: {
                        value: _vm.questionWords,
                        callback: function($$v) {
                          _vm.questionWords = $$v
                        },
                        expression: "questionWords"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.addQuestion.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v("手动录入问题")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.toLoadQuestion.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v("表格导入问题")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "normal" },
              [
                _vm._v("\n        操作：\n        "),
                _c(
                  "el-select",
                  {
                    on: { change: _vm.getQuestion },
                    model: {
                      value: _vm.operate,
                      callback: function($$v) {
                        _vm.operate = $$v
                      },
                      expression: "operate"
                    }
                  },
                  [
                    _c("el-option", {
                      attrs: { label: "匹配", value: "匹配" }
                    }),
                    _vm._v(" "),
                    _c("el-option", { attrs: { label: "核对", value: "核对" } })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", { staticStyle: { "margin-left": "20px" } }, [
                  _vm._v("状态：")
                ]),
                _vm._v(" "),
                _vm.operate === "匹配"
                  ? _c(
                      "el-select",
                      {
                        on: { change: _vm.getQuestion },
                        model: {
                          value: _vm.matchStatus,
                          callback: function($$v) {
                            _vm.matchStatus = $$v
                          },
                          expression: "matchStatus"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "未匹配", value: "未匹配" }
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "已匹配", value: "已匹配" }
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "待定", value: "待定" }
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "疑难", value: "疑难" }
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "不答", value: "不答" }
                        })
                      ],
                      1
                    )
                  : _c(
                      "el-select",
                      {
                        on: { change: _vm.getQuestion },
                        model: {
                          value: _vm.checkStatus,
                          callback: function($$v) {
                            _vm.checkStatus = $$v
                          },
                          expression: "checkStatus"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "未核对", value: "未核对" }
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "已核对", value: "已核对" }
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "二轮核对", value: "二轮核对" }
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "灌水", value: "灌水" }
                        })
                      ],
                      1
                    )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("el-input", {
                  attrs: { size: "mini", placeholder: "输入关键字搜索" },
                  model: {
                    value: _vm.tableSearch,
                    callback: function($$v) {
                      _vm.tableSearch = $$v
                    },
                    expression: "tableSearch"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.operate === "匹配" && _vm.matchStatus === "已匹配"
              ? _c(
                  "div",
                  { staticClass: "normal" },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "date",
                        "value-format": "yyyy-MM-dd",
                        placeholder: "选择日期"
                      },
                      on: {
                        change: function($event) {
                          return _vm.init()
                        }
                      },
                      model: {
                        value: _vm.checkDate,
                        callback: function($$v) {
                          _vm.checkDate = $$v
                        },
                        expression: "checkDate"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mtop" },
              [
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: _vm.filterResult,
                      border: "",
                      stripe: "",
                      height: _vm.tableHeight - 170 - 30
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "content",
                        label:
                          "问题" +
                          _vm.allQuestion.length +
                          "/" +
                          _vm.filterResult.length
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "操作", width: "600" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.status > 1 && scope.row.status < 4
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "plain" },
                                      on: {
                                        click: function($event) {
                                          return _vm.matchQuestion(
                                            scope.row,
                                            "cancel"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("取消匹配")]
                                  )
                                : scope.row.status === 7
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "plain" },
                                      on: {
                                        click: function($event) {
                                          return _vm.matchQuestion(
                                            scope.row,
                                            "cancel"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("取消匹配")]
                                  )
                                : _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.matchQuestion(
                                            scope.row,
                                            "match"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("匹配")]
                                  ),
                              _vm._v(" "),
                              !(
                                _vm.operate === "匹配" &&
                                _vm.matchStatus === "待定"
                              )
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "warning" },
                                      on: {
                                        click: function($event) {
                                          return _vm.matchQuestion(
                                            scope.row,
                                            "wait"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("待定")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.operate === "匹配" &&
                              ["未匹配", "待定", "不答"].includes(
                                _vm.matchStatus
                              )
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "warning" },
                                      on: {
                                        click: function($event) {
                                          return _vm.matchQuestion(
                                            scope.row,
                                            "diff"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("疑难")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.operate === "匹配" &&
                              _vm.matchStatus !== "已匹配"
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "danger" },
                                      on: {
                                        click: function($event) {
                                          return _vm.matchQuestion(
                                            scope.row,
                                            "delete"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("删除")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.operate === "核对" && scope.row.status < 3
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.matchQuestion(
                                            scope.row,
                                            "check"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("核对正确")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.operate === "核对" &&
                              (scope.row.status == 3 || scope.row.status == 9)
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.matchQuestion(
                                            scope.row,
                                            "check2"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("二轮核对")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.remarkQuestion(scope.row)
                                    }
                                  }
                                },
                                [_vm._v("修改")]
                              ),
                              _vm._v(" "),
                              (_vm.operate === "匹配" &&
                                (_vm.matchStatus === "疑难" ||
                                  _vm.matchStatus === "待定")) ||
                              _vm.matchStatus === "未匹配"
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.matchQuestion(
                                            scope.row,
                                            "silence"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("不答")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.operate === "核对" && scope.row.status == 7
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.matchQuestion(
                                            scope.row,
                                            "water"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("灌水")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.operate === "核对"
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "warning" },
                                      on: {
                                        click: function($event) {
                                          return _vm.matchQuestion(
                                            scope.row,
                                            "diff"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("疑难")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "success",
                                    disabled:
                                      scope.row.label &&
                                      scope.row.label.includes("政策测试集")
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.joinExamine(scope)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.buttonContent)
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("el-pagination", {
              attrs: {
                background: "",
                layout: "prev, pager, next",
                "page-size": _vm.pageSize,
                "prev-text": "上一页",
                "next-text": "下一页",
                total: _vm.allQuestion.length
              },
              on: { "current-change": _vm.changePage },
              model: {
                value: _vm.page,
                callback: function($$v) {
                  _vm.page = $$v
                },
                expression: "page"
              }
            })
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f29b0d18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f29b0d18","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/AutoReply.vue
// module id = null
// module chunks = 